import defaultSettings from '@/settings'

const { showSettings, fixedHeader, sidebarLogo } = defaultSettings

const state = {
  isrefresh:false,
  showSettings: showSettings,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  plateColorSelect: [
    { label: '黄牌', value: 1 },
    { label: '蓝牌', value: 2 },
    { label: '绿牌', value: 3 },
    { label: '其他', value: 4 },
    { label: '黑牌', value: 5 },
    { label: '白牌', value: 6 },
    
  ]
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  },
  changeIsrefresh:(state,data)=>{
    state.isrefresh = data;
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
